import React from "react";
import { format } from "date-fns";

export default function RestlessDateFormatter(cellContent) {
  const date = cellContent
    ? format(new Date(cellContent), "MMMM dd, yyyy")
    : "No date registered";

  return (
    <div>
      <strong>{date}</strong>
    </div>
  );
}
